<template>
	<div class="grid-flex-container" v-if="canView">
		<v-container fluid>
			<v-row no-gutters>
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn v-if="canAdd" color="primary" @click="addUser()">
						<v-icon> mdi-plus</v-icon>
						&nbsp;&nbsp;Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				v-if="canView"
				:headers="headers"
				:items="items"
				:search.sync="search"
				:sort-desc="[true]"
				:loading="loading"
				:disable-pagination="true"
				hide-default-footer
				loading-text="Loading..."
				fixed-header
				multi-sort
				dense
			>
				<template v-slot:[`item.LastLogin`]="{ item }">
					{{ getDateTimeFormat(item.LastLogin) }}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<div class="d-flex">
						<v-spacer />
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="success"
							v-if="canView"
							@click="editUser(item)"
						>
							<v-icon small> mdi-pencil </v-icon>
						</v-btn>
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="error"
							v-if="canDelete"
							@click="deleteUser(item.Id)"
						>
							<v-icon small> mdi-delete</v-icon>
						</v-btn>
					</div>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { ClientUserManagementActions } from '../../../store/actions';
import { ClientUserManagementGetters } from '../../../store/getters';
import { Permissions } from '../../../enums/permissionsEnum';
import permissionsMixin from '../../../mixins/permissionsMixin';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';
export default {
	components: {},
	mixins: [permissionsMixin, projectSettingsMixin],
	name: 'ClientUserManagement',
	data() {
		return {
			showDialog: false,
			headers: [
				{
					text: 'Last Name',
					value: 'LastName',
				},
				{
					text: 'First Name',
					value: 'FirstName',
				},
				{
					text: 'Email',
					value: 'Email',
				},
				{
					text: 'Last Login',
					value: 'LastLogin',
				},

				{
					sortable: false,
					text: '',
					value: 'actions',
				},
			],
			search: '',
		};
	},
	computed: {
		...mapGetters({
			items: [ClientUserManagementGetters.GET_DATA],
			loading: [ClientUserManagementGetters.GRID_LOADING],
			selectedUser: [ClientUserManagementGetters.GET_SELECTED_USER],
		}),
		canView() {
			return this.hasPermissions([Permissions.Tools.UserManagement.View]);
		},
		canAdd() {
			return this.hasPermissions([Permissions.Tools.UserManagement.Add]);
		},
		canEdit() {
			return this.hasPermissions([Permissions.Tools.UserManagement.Edit]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.UserManagement.Delete,
			]);
		},
	},
	mounted() {
		this.getUsers();
	},
	destroyed() {
		this.$store.dispatch(ClientUserManagementActions.CLEAR);
	},
	methods: {
		getUsers() {
			this.$store.dispatch(ClientUserManagementActions.LOAD_DATA);
		},
		deleteUser(id) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this user?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$store
						.dispatch(ClientUserManagementActions.DELETE, id)
						.then(() => {
							this.getUsers();
						});
				}
			});
		},
		editUser(item) {
			this.$router.push({
				name: 'ClientUserManagementEdit',
				params: { id: item.Id },
			});
		},
		submit(formUser) {
			this.$store
				.dispatch(ClientUserManagementActions.INSERT, formUser)
				.then(() => {
					this.$router.push({
						name: 'ClientUserManagementEdit',
						params: { id: this.selectedUser.Id },
					});
				});
		},
		addUser() {
			this.$router.push({
				name: 'ClientUserManagementAdd',
			});
		},
	},
};
</script>
